// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__yRQpf","title":"ClientInsurance_title__3fSct","itemText":"ClientInsurance_itemText__1hAMK"};